"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
// import { ToastSuccess } from "../../../../../../../routes/resources/js/src/common/Toast";
// import TextInput from "../../../../common/TextInput/TextInput";
var lodash_1 = __importDefault(require("lodash"));
var Toast_1 = require("../../../../common/Toast");
var general_1 = require("../../../../lib/general");
var Mutation_1 = require("../../Graphql/Mutation");
var Queries_1 = require("../../Graphql/Queries");
var validate_1 = require("../validate");
var QuestionTable_1 = __importDefault(require("./QuestionTable"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var Spinner_1 = __importDefault(require("../../../../common/Spinner/Spinner"));
var KnowledgeQuestion = function (props) {
    var _a, _b, _c, _d, _e;
    var organization = (0, org_hook_1.useOrg)().organization;
    var _f = (0, react_1.useState)(null), error = _f[0], setError = _f[1];
    var _g = (0, react_i18next_1.useTranslation)(), t = _g.t, i18n = _g.i18n;
    var getCurrentLang = i18n.language;
    var _h = (0, react_1.useState)({
        id: null,
        name: JSON.stringify(props.languages),
        category: null,
        exam_type: null,
        data_type: null,
        sorting_order: null,
        answer: [],
        organization_id: organization.id,
    }), formData = _h[0], setFormData = _h[1];
    var _j = (0, react_1.useState)(null), success = _j[0], setSuccess = _j[1];
    var _k = (0, react_1.useState)([]), questionSortingArr = _k[0], setQuestionSortingArr = _k[1];
    var _l = (0, react_1.useState)(false), deleteModal = _l[0], setDeleteModal = _l[1];
    var _m = (0, react_1.useState)(null), deleteRow = _m[0], setDeleteRow = _m[1];
    var _o = (0, client_1.useLazyQuery)(Queries_1.GET_EXAM_QUESTION_ORDER, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), getExamKnowledge = _o[0], examKnowledgeResponse = _o[1];
    var _p = (0, client_1.useMutation)(Mutation_1.UPSERT_KNOWLEDGE_QUESTION_ANSWER, {
        fetchPolicy: "network-only",
        refetchQueries: ["getKnowledgeCategory"],
    }), upsertExamQuestion = _p[0], upsertExamQuestionResponse = _p[1];
    var getQuestionAnswer = (0, client_1.useLazyQuery)(Queries_1.GET_QUESTION_ANSWER, {
        variables: { organization_id: organization.id },
    })[0];
    var updateQuestionExamStatus = (0, client_1.useMutation)(Mutation_1.UPDATA_QUESTION_EXAM_STATUS, {
        fetchPolicy: "network-only",
        refetchQueries: ["getKnowledgeCategory"],
    })[0];
    (0, react_1.useEffect)(function () {
        getQuestionAnswer();
        setFormData({
            id: null,
            name: JSON.stringify(props.languages),
            category: null,
            exam_type: null,
            data_type: null,
            sorting_order: null,
            answer: [],
            organization_id: organization.id,
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (props.clickStatus) {
            props.updateSaveClickStatus();
            saveQuestionAnswer();
        }
    }, [props.clickStatus]);
    var saveQuestionAnswer = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var validateResponse = (0, validate_1.ValidateKnowledgeQuestion)(formData, getCurrentLang);
        if (validateResponse.status === "error") {
            setError(validateResponse);
        }
        else {
            var payload = {
                id: formData.id,
                knowledge_category_id: ((_a = formData.category) === null || _a === void 0 ? void 0 : _a.id)
                    ? (_b = formData.category) === null || _b === void 0 ? void 0 : _b.id
                    : formData.category,
                exam_type_id: ((_c = formData.exam_type) === null || _c === void 0 ? void 0 : _c.id)
                    ? (_d = formData.exam_type) === null || _d === void 0 ? void 0 : _d.id
                    : formData.exam_type,
                question: formData.name,
                order_by: formData.sorting_order !== null
                    ? parseInt(((_e = formData.sorting_order) === null || _e === void 0 ? void 0 : _e.value)
                        ? (_f = formData.sorting_order) === null || _f === void 0 ? void 0 : _f.value
                        : formData.sorting_order)
                    : null,
                data_type_id: ((_g = formData.data_type) === null || _g === void 0 ? void 0 : _g.id)
                    ? (_h = formData.data_type) === null || _h === void 0 ? void 0 : _h.id
                    : formData.data_type,
                status: true,
                answer: formData.answer,
                organization_id: organization.id,
            };
            upsertExamQuestion({
                variables: {
                    input: [payload],
                },
            })
                .then(function (res) {
                setSuccess(res.data.upsertQuestionAnswer);
                reformatForm();
            })
                .catch(function () { });
        }
    };
    var reformatForm = function () {
        setFormData({
            id: null,
            name: JSON.stringify(props.languages),
            category: null,
            exam_type: null,
            data_type: null,
            sorting_order: null,
            answer: [],
            organization_id: organization.id,
        });
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if (formData.exam_type && formData.category && formData.organization_id) {
            getExamKnowledge({
                variables: {
                    knowledge_category_id: ((_a = formData.category) === null || _a === void 0 ? void 0 : _a.id)
                        ? (_b = formData.category) === null || _b === void 0 ? void 0 : _b.id
                        : formData.category,
                    exam_type_id: ((_c = formData.exam_type) === null || _c === void 0 ? void 0 : _c.id)
                        ? (_d = formData.exam_type) === null || _d === void 0 ? void 0 : _d.id
                        : formData.exam_type,
                    organization_id: organization.id,
                },
            });
        }
    }, [formData]);
    var onHandleChange = function (value, name, type) {
        setError(null);
        if (type === "json") {
            var dataObj_1 = JSON.parse(formData[name]);
            dataObj_1[getCurrentLang] = value;
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = JSON.stringify(dataObj_1), _a)));
            });
        }
        else {
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
            });
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        setQuestionSortingArr([]);
        if (((_b = (_a = examKnowledgeResponse === null || examKnowledgeResponse === void 0 ? void 0 : examKnowledgeResponse.data) === null || _a === void 0 ? void 0 : _a.getQuestionOrder) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            var list = (_c = examKnowledgeResponse === null || examKnowledgeResponse === void 0 ? void 0 : examKnowledgeResponse.data) === null || _c === void 0 ? void 0 : _c.getQuestionOrder;
            var output_1 = [];
            list.map(function (item) {
                var id = item.id, order_by = item.order_by, question = item.question, value = order_by, label = "before ".concat((0, general_1.isJsonWithAvailableLang)(question, getCurrentLang, t)), sorting_id = order_by;
                output_1.push({
                    id: id,
                    value: value,
                    label: lodash_1.default.truncate(label, {
                        length: 60,
                        omission: " ...",
                    }),
                    sorting_id: sorting_id,
                    question: question,
                });
            });
            setQuestionSortingArr(output_1);
        }
    }, [examKnowledgeResponse, getCurrentLang, formData]);
    (0, react_1.useEffect)(function () {
        if (success) {
            var timer_1 = setTimeout(function () {
                setSuccess(null);
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [success]);
    var onDeleteQuestion = function () {
        updateQuestionExamStatus({
            variables: {
                id: deleteRow.id,
                status: false,
                organization_id: organization.id,
            },
        }).then(function () {
            reformatForm();
            setDeleteModal(false);
            setDeleteRow(null);
            setSuccess("deleted_successfully");
        });
    };
    var onEditQuestion = function (item) {
        var formatted_exam_type = {
            id: item.exam_type.id,
            value: item.exam_type.id,
            label: (0, general_1.isJsonWithAvailableLang)(item.exam_type.name, getCurrentLang, t),
            name: item.exam_type.name,
        };
        var output = [];
        if (item.answers.length > 0) {
            item.answers.map(function (l) {
                var answer = l.answer, description = l.description, id = l.id, is_correct = l.is_correct, order_by = l.order_by, status = l.status;
                output.push({
                    answer: answer,
                    description: description,
                    is_correct: is_correct,
                    id: id,
                    order_by: order_by,
                    status: status,
                });
            });
        }
        var payload = {
            id: item.id,
            name: item.question,
            category: item.knowledge_category_id,
            exam_type: item.exam_type.id,
            exam_type_item: formatted_exam_type,
            data_type: item.data_type_id,
            data_type_item: item.data_type,
            sorting_order: item.order_by,
            answer: output,
            organization_id: organization.id,
        };
        setFormData(payload);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (upsertExamQuestionResponse === null || upsertExamQuestionResponse === void 0 ? void 0 : upsertExamQuestionResponse.loading) && react_1.default.createElement(Spinner_1.default, null),
        (((_a = upsertExamQuestionResponse === null || upsertExamQuestionResponse === void 0 ? void 0 : upsertExamQuestionResponse.data) === null || _a === void 0 ? void 0 : _a.upsertExamQuestion) || success) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t(((_b = upsertExamQuestionResponse === null || upsertExamQuestionResponse === void 0 ? void 0 : upsertExamQuestionResponse.data) === null || _b === void 0 ? void 0 : _b.upsertExamQuestion) || success), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        react_1.default.createElement(QuestionTable_1.default, { list: ((_e = (_d = (_c = props.getResponse) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.getKnowledgeCategory) === null || _e === void 0 ? void 0 : _e.length) > 0
                ? props.getResponse.data.getKnowledgeCategory
                : [] })));
};
exports.default = KnowledgeQuestion;
